import SimpleVueValidation from 'simple-vue-validator';
import Vue from 'vue';
Vue.use(SimpleVueValidation);
